 export function initStatsPods() {
   if (window.acf) {
     window.acf.addAction(
       'render_block_preview/type=stats-pods',
       statsPods
     );
   }
 }

 export function statsPods() {
   let charts = document.getElementsByClassName('mkc_circle-chart');

   var intersectionObserver = new IntersectionObserver(function (entries) {

     [...entries].forEach(function (v, i, a) {

       let animationCircle = v.target.querySelector('.mkc_circle');

       // If intersectionRatio is 0, the target is out of view
       // and we do not need to do anything.
       if (v.intersectionRatio <= 0) {
        animationCircle.classList.remove('animate');
         animationCircle.setAttribute('stroke-dashoffset', '100');
         return
       };

       // object in view, do something
       animationCircle.setAttribute('stroke-dashoffset', (100 - v.target.dataset.percentage));
       animationCircle.classList.add('animate');

     });

   });

   [...charts].forEach(function (v, i, a) {
     intersectionObserver.observe(v);
   });
 }
